import React, { useState } from "react";
import { Button, Paper, TextField } from "@mui/material";
import SettingsModal from "./columnHeadersForReport/SettingsModal";
import DynamicFiltersModal from "./customFilterForReport/DynamicFiltersModal";
import { DateFilter, Filter } from "../../../@types/dateFilter.types";
import { FilterState, ReportBoxProps } from "../../../@types/appealReportAllprops.types";

const ReportBox: React.FC<ReportBoxProps> = ({
	group_name,
	selectedColumns,
	filteredColumns,
	filters,
	handleUpdateSelectedColumns,
	handleUpdateFiltersSelection,
	handleFilterChange,
	appealsIDRTrackersCommonUnion,
	handleAppealsIDRTrackersCommonUnionChange
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [addFilterModalOpen, setAddFilterModalOpen] = useState(false);

	const claimsNameArray = ["paidclaims", "idrtrackers", "appeals"];

	const handleModalOpen = () => setModalOpen(true);
	const handleModalClose = () => setModalOpen(false);

	const handleAddFilterModalOpen = () => setAddFilterModalOpen(true);
	const handleAddFilterModalClose = () => setAddFilterModalOpen(false);

	const ensureDateFilter = (component: keyof FilterState, field: string): DateFilter => {
		const currentFilter = filters[component]?.[field];
		if (typeof currentFilter === "object" && currentFilter !== null) {
			if ("startDate" in currentFilter) {
				return currentFilter as DateFilter;
			}
		}
		return { startDate: "", endDate: "" };
	};

	return (
		<div style={{ marginTop: 30 }}>
			<Paper elevation={3} style={{ padding: 20 }}>
				<div>
					<h2 className="blue-text">Appeal Claim Report Generation</h2>
				</div>
				<div className="inline-flex" style={{ justifyContent: "space-between" }}>
					<div style={{ display: "flex", gap: 40 }}>
						<p className="form-label">Group Name</p>
						<TextField
							id="standard-basic"
							label="Group Name"
							value={group_name}
							variant="outlined"
							style={{ minWidth: "30%" }}
						/>
					</div>
					<div>
						<Button
							variant="contained"
							className="button-blue-light-v2"
							style={{
								color: "#963D51",
								borderColor: "#963D51",
								fontWeight: "bold",
								padding: "4px 10px",
								borderRadius: "10px"
							}}
							onClick={handleModalOpen}
						>
							Choose Column Headers for Report
						</Button>
						<Button
							variant="contained"
							className="button-blue-light-v2"
							style={{
								color: "#963D51",
								borderColor: "#963D51",
								fontWeight: "bold",
								padding: "4px 10px",
								borderRadius: "10px",
								marginLeft: "20px"
							}}
							onClick={handleAddFilterModalOpen}
						>
							Add Filter
						</Button>
					</div>
				</div>
			</Paper>

			{/* Modal Integration */}
			<SettingsModal
				open={modalOpen}
				onClose={handleModalClose}
				selectedColumns={selectedColumns}
				handleUpdateSelectedColumns={handleUpdateSelectedColumns}
				claimsNameArray={claimsNameArray}
				appealsIDRTrackersCommonUnion={appealsIDRTrackersCommonUnion}
				handleAppealsIDRTrackersCommonUnionChange={handleAppealsIDRTrackersCommonUnionChange}
			/>
			<DynamicFiltersModal
				open={addFilterModalOpen}
				onClose={handleAddFilterModalClose}
				filteredColumns={filteredColumns}
				filters={filters}
				handleUpdateFiltersSelection={handleUpdateFiltersSelection}
				handleFilterChange={handleFilterChange}
				appealsIDRTrackersCommonUnion={appealsIDRTrackersCommonUnion}
				ensureDateFilter={ensureDateFilter}
			/>
		</div>
	);
};

export default ReportBox;
